import { produce } from 'immer';
import { APP_IS_INITIALIZED } from "redux/appInit/actions";

export const initialState = {
  initialized: false
}

const appInit = (state = initialState, action) => produce(state, draft => {
  switch (action.type) {
    case APP_IS_INITIALIZED:
      draft.initialized = true
      break
    default:
      break
  }
})
export default appInit